import { IChecklistDefinition } from "../../customTypings/task/ChecklistDefinition";
import {
    faPen,
    faPlus,
    faTrash,
    faTrashArrowUp
} from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { AddNewChecklist, EditChecklist } from "../../components/features/task";
import { ResponsiveBreadcrumb } from "../../components/Layout/ResponsiveBreadcrumb";
import {
    ColumnRender,
    FilterType,
    IColumn,
    IFilter,
    IPagedListAction
} from "../../components/UI/Declarations";
import { PagedList } from "../../components/UI/PagedList";
import { checklistDefinitionService } from "../../services";

export default function ChecklistSettingsPage() {
    const [showAdd, setShowAdd] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [editId, setEditId] = useState("");

    const [refreshNumber, setRefeshNumber] = useState(0);

    const handleAdd = (added: boolean) => {
        if (added) {
            setRefeshNumber(refreshNumber + 1);
        }
        setShowAdd(false);
    };

    const handleEdit = (updated: boolean) => {
        if (updated) {
            setRefeshNumber(refreshNumber + 1);
        }
        setShowEdit(false);
    };

    const handleDeleted = (item: IChecklistDefinition) => {
        checklistDefinitionService.remove(item.id ?? "").then(
            (response) => {
                if (response.status !== "Failure") {
                    setRefeshNumber(refreshNumber + 1);
                } else {
                    console.log(response.message);
                }
            },
            (error) => {
                if (error.status === 400) {
                    console.log(error.title);
                } else {
                    console.log(error);
                }
            }
        );
    };

    const handleRestore = (item: IChecklistDefinition) => {
        checklistDefinitionService.restore(item.id ?? "").then(
            (response) => {
                if (response.status !== "Failure") {
                    setRefeshNumber(refreshNumber + 1);
                } else {
                    console.log(response.message);
                }
            },
            (error) => {
                if (error.status === 400) {
                    console.log(error.title);
                } else {
                    console.log(error);
                }
            }
        );
    };

    return (
        <Container fluid>
            <Helmet>
                <title>Checklists</title>
            </Helmet>

            <ResponsiveBreadcrumb
                items={[
                    { text: "Settings", to: "/settings" },
                    { text: "Checklists" },
                ]}
            />
            <Row>
                <Col>
                    <h1 className="my-3">Checklist Definitions</h1>
                    <PagedList
                        columns={[
                            {
                                member: "name",
                                renderAs: ColumnRender.text,
                                title: "Name",
                                width: 100,
                            } as IColumn,
                            {
                                member: "type",
                                renderAs: ColumnRender.text,
                                title: "Type",
                                width: 100,
                            } as IColumn,
                        ]}
                        itemActions={[
                            {
                                icon: faPen,
                                text: "Edit",
                                onClick: (item) => {
                                    setEditId(item.id);
                                    setShowEdit(true);
                                },
                                primary: true,
                            } as IPagedListAction,
                            {
                                icon: faTrash,
                                text: "Delete",
                                onClick: (item) => {
                                    handleDeleted(item);
                                },
                                availableMember: "isDeleted",
                                availableFliped: true,
                            } as IPagedListAction,
                            {
                                icon: faTrashArrowUp,
                                text: "Restore",
                                onClick: (item) => {
                                    handleRestore(item);
                                },
                                availableMember: "isDeleted",
                            } as IPagedListAction,
                        ]}
                        headActions={[
                            {
                                icon: faPlus,
                                text: "Add Entry",
                                onClick: () => {
                                    setShowAdd(true);
                                },
                            } as IPagedListAction,
                        ]}
                        filters={[
                            {
                                title: "Name",
                                member: "name",
                                type: FilterType.text,
                            } as IFilter,
                            {
                                title: "Type",
                                member: "type",
                                type: FilterType.text,
                            } as IFilter,
                            {
                                title: "Deleted",
                                member: "isDeleted",
                                type: FilterType.select,
                                options: { All: null, Yes: true, No: false },
                                defaultValue: false,
                            } as IFilter,
                        ]}
                        defaultSortBy="Name"
                        getUrl="/api/checklistdefinition/all"
                        avatarUrl="/api/avatar/get"
                        rowFormatter={(item: any) => {
                            return null;
                        }}
                        persistanceKey="ChecklistSettingsPage"
                        showDeletedRowIndicator
                        refreshNumber={refreshNumber}
                    />
                </Col>
            </Row>
            <AddNewChecklist show={showAdd} onClose={handleAdd} />
            <EditChecklist
                show={showEdit}
                onClose={handleEdit}
                checklistDefinitionId={editId}
            />
        </Container>
    );
}
